// extracted by mini-css-extract-plugin
export default {"inner":"wqxcTrAES9i284zPLxqQ","balloons":"yRGf7NsRLVyg6AoF4skF","title":"am3pONJoFpfTuSKwRZrg"};